// NOTE: shape mirrors apps/nsai/desktop/src/types.ts IDesktopBridge.
// The bridge is exposed by the Electron preload script via
// contextBridge.exposeInMainWorld("nsai", ...). In a regular browser
// `window.nsai` is undefined.

export interface ISetTenantUrlResult {
  ok: boolean;
  error?: string;
}

export interface IDesktopBridge {
  isDesktop: true;
  platform: string;
  appVersion: string;
  openExternal: (url: string) => Promise<void>;
  getTenantUrl: () => Promise<string>;
  getDefaultTenantUrl: () => Promise<string>;
  setTenantUrl: (url: string) => Promise<ISetTenantUrlResult>;
  resetTenantUrl: () => Promise<ISetTenantUrlResult>;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    nsai?: IDesktopBridge;
  }
}

export const getDesktopBridge = (): IDesktopBridge | undefined => window.nsai;
